import { Divider } from 'antd'

import { LastDamages } from './LastDamages'
import { SpecialCargoTypes } from './SpecialCargoTypes'
import { TransportActivity } from './TransportActivity'
import { Vehicles } from './Vehicles'

export const TransportItems = () => (
  <>
    <TransportActivity />
    <Divider />
    <SpecialCargoTypes />
    <Divider />
    <Vehicles />
    <Divider />
    <LastDamages />
  </>
)
